import { __awaiter, __generator, __read } from "tslib";
import React from 'react';
import Loadable from 'react-loadable';
import { getExtensionKeyAndNodeKey, resolveImport } from './manifest-helpers';
export function getExtensionModuleNode(extensionProvider, extensionType, extensionKey) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, extKey, nodeKey, manifest, node;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = __read(getExtensionKeyAndNodeKey(extensionKey), 2), extKey = _a[0], nodeKey = _a[1];
                    return [4 /*yield*/, extensionProvider.getExtension(extensionType, extKey)];
                case 1:
                    manifest = _b.sent();
                    if (!manifest) {
                        throw new Error("Extension with key \"" + extKey + "\" and type \"" + extensionType + "\" not found!");
                    }
                    if (!manifest.modules.nodes) {
                        throw new Error("Couldn't find any node for extension type \"" + extensionType + "\" and key \"" + extensionKey + "\"!");
                    }
                    node = manifest.modules.nodes[nodeKey];
                    if (!node) {
                        throw new Error("Node with key \"" + extensionKey + "\" not found on manifest for extension type \"" + extensionType + "\" and key \"" + extensionKey + "\"!");
                    }
                    return [2 /*return*/, node];
            }
        });
    });
}
function ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return React.createElement("div", null, "Error loading the extension!");
    }
    else {
        return null;
    }
}
export function getNodeRenderer(extensionProvider, extensionType, extensionKey) {
    return Loadable({
        loader: function () {
            return getExtensionModuleNode(extensionProvider, extensionType, extensionKey).then(function (node) { return resolveImport(node.render()); });
        },
        loading: ExtensionLoading,
    });
}
//# sourceMappingURL=extension-handlers.js.map